import Cookie from 'js-cookie';

export const stringToLetters = (text) => {
	let wordLength = text.split(' ');

	return wordLength.map((i, k) => {
		return (
			<span
				key={k}
				className='word'>
				{i}
			</span>
		);
	});
};

export const setCookie = (key, cookie) => {
	Cookie.set(key, cookie);
};

export const removeCookie = (key) => {
	Cookie.remove(key);
};

export const getRequestCookies = (ctx, key) => {
	return ctx?.req?.cookies?.[key];
};

export const getCookie = (key) => {
	return Cookie.get(key);
};

export const getParamsByKey = (params, key) => {
	return params.get(key)?.split(',');
};

export const createQueryString = ({ searchParams, typeId, type, multiple }) => {
	const params = new URLSearchParams(searchParams);

	let newVal = typeId?.toString();

	if (multiple) {
		let paramsArr = getParamsByKey(params, type);

		if (paramsArr) {
			paramsArr = paramsArr.indexOf(newVal) > -1 ? paramsArr.filter((k) => k !== newVal) : [...paramsArr, newVal];
			newVal = paramsArr.join(',');
		}
	}

	if (!newVal || params.has(type, newVal)) {
		params.delete(type);
	} else {
		params.set(type, newVal);
	}

	if (type != 'page' && params.has('page')) {
		params.delete('page');
	}

	return params.toString();
};

export const objectToFormData = (data, formData, parentKey) => {
	const newFormData = formData || new FormData();

	if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
		Object.keys(data).forEach((key) => {
			objectToFormData(data[key], newFormData, parentKey ? `${parentKey}[${key}]` : key);
		});
	} else {
		const value = data == null ? '' : data;

		newFormData.append(parentKey, value);
	}

	return newFormData;
};

export const numToLocalString = (num) => {
	if (typeof num === 'string') {
		return Number(num).toLocaleString();
	} else if (num !== undefined) {
		return num.toLocaleString();
	}
};

export const handlePriceCheckFunc = (price, currency = null) => {
	let val;

	val = price ? (typeof price === 'string' ? price.split('-') : price) : null;

	if (typeof val === 'object' && val?.length > 1) {
		return `${numToLocalString(val[0])} ${currency} - ${numToLocalString(val[1])} ${currency}`;
	} else {
		return `${numToLocalString(typeof val === 'object' ? val[0] : val)} ${currency}`;
	}
};

export const fileToUploadObj = (file) => {
	return {
		uid: file.id,
		name: file.filename,
		status: 'done',
		url: file.src,
	};
};

export const ucFirst = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const cleanObject = (obj) => {
	return Object.fromEntries(
		Object.entries(obj).filter(
			([_, value]) =>
				value !== null &&
				value !== undefined &&
				value !== '' &&
				!(Array.isArray(value) && value.length === 0) &&
				!(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
		)
	);
};
